import React from 'react';

// Style
import { st, classes } from './Loader.st.css';

const Loader = ({ isVisible }) => {
  if (!isVisible) {
    return null;
  }
  return (
    <svg className={classes.spinner} viewBox="0 0 50 50">
      <circle
        className={classes.path}
        cx="25"
        cy="25"
        r="20"
        strokeWidth="3"
      ></circle>
    </svg>
  );
};

export default Loader;
